import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map } from 'rxjs';

// Components
import { AlertComponent } from '../../../../../../shared/_components/alert/alert.component';
import { ButtonComponent } from '../../../../../../shared/_components/button/button.component';
import { CheckboxComponent } from '../../../../../../shared/_components/checkbox/checkbox.component';
import { RadioButtonComponent } from '../../../../../../shared/_components/radio-button/radio-button.component';
import { TextAreaComponent } from '../../../../../../shared/_components/text-area/text-area.component';
import { FlowMediaUploadStep } from '../../flows/flow-media-upload/step/flow-media-upload-step.component';
import { PostPreviewComponent } from '../../post-preview/post-preview.component';

// Models
import { IntegrationProvider } from '../../../../../models/integration-providers.model';

@Component({
  selector: 'pp-step-integration-facebook',
  templateUrl: './step-integration-facebook.component.html',
  imports: [CommonModule, AlertComponent, ButtonComponent, CheckboxComponent, PostPreviewComponent, RadioButtonComponent, TextAreaComponent],
})
export class StepIntegrationFacebookComponent extends FlowMediaUploadStep implements OnInit, AfterViewInit {

  // Component handler (!IMPORTANT - Must match step identifier for this flow)
  identifier = 'mediaUploadFlowStepIntegrationFacebook';

  // Facebook pages
  pages: { id: string; name: string }[] = [];

  constructor() {
    super();

    this.form = new FormGroup({
      fbPostTitle: new FormControl<string>(''),
      fbPostDescription: new FormControl<string>('', Validators.required),
      fbPageSelection: new FormControl<string>('', Validators.required),
      fbIncludeOddrLink: new FormControl<boolean>(true),
    });
  }

  ngOnInit(): void {
    this.mediaUploadService.activeIntegrationsList$
      .pipe(
        map(integrations => {
          const facebookIntegration = integrations.find(i => i.id === 'facebook');
          return (facebookIntegration as any)?.properties?.pages || [];
        }),
      )
      .subscribe(pages => {
        this.pages = pages;
        if (pages.length === 1) this.form.get('fbPageSelection')?.setValue(pages[0].id);
        this.cdr.markForCheck();
      });
  }

  ngAfterViewInit(): void {
    this.form.get('fbPostTitle')?.setValue(this.operation?.title ?? '');
    this.form.get('fbPostDescription')?.setValue('');
  }

  pageSelected(pageId: string): void {
    this.form.get('fbPageSelection')?.setValue(pageId);
  }

  oddrLinkSelected(include: boolean): void {
    this.form.get('fbIncludeOddrLink')?.setValue(include);
  }

  submitAndGoToNextStep(): void {
    const selectedPageId = this.form.get('fbPageSelection')?.value;
    const selectedPage = this.pages.find(p => p.id === selectedPageId);

    if (!selectedPage) return;

    this.mediaUploadService.storeSelectedIntegrationPayload(
      this.constructAndStorePayloadForProvider(selectedPage),
    ).subscribe({
      next: () => this.goToNextStep(),
    });
  }

  private constructAndStorePayloadForProvider(selectedPage: { id: string; name: string }): any {
    const payload = {
      title: this.form.get('fbPostTitle')?.value as string,
      description: this.form.get('fbPostDescription')?.value as string,
      pageId: selectedPage.id,
      pageName: selectedPage.name,
      includeOddrLink: this.form.get('fbIncludeOddrLink')?.value as boolean,
    };
    return this.cleanIntegrationPayload(IntegrationProvider.Facebook, payload);
  }
}
